var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"register-login"},[_c('div',{staticClass:"container"},[_c('Header',{attrs:{"text":_vm.headerText}}),_c('FormRegisterFast',{attrs:{"type":_vm.type}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }